import {
  deserializeValidationProblemDetails,
  ProblemDetails,
  ValidationProblemDetails,
} from '@lmt/shared-types';

export const NetworkError = 'Network Error';
export const ReactRouter404 = 'ReactRouter404';

export function parseError(e: any): string {
  try {
    if (e.detail) {
      return e.detail;
    }
    if ('errors' in (e as ValidationProblemDetails)) {
      return extractErrorMessageFromValidationProblemDetails(e);
    } else {
      const jsonDetails = deserializeValidationProblemDetails(e.response);
      if (jsonDetails.detail) {
        return extractErrorMessageFromValidationProblemDetails(jsonDetails);
      }

      return e.message;
    }
  } catch (error) {
    console.log(error);
    return e.message;
  }
}

function extractErrorMessageFromValidationProblemDetails(
  validationProblemDetails: ValidationProblemDetails,
) {
  const errors = validationProblemDetails.errors;
  if (errors) {
    const errorMessage = Object.keys(errors)
      // we need to show `objectKey` when editing DataBlocks, otherwise it's not clear to what field 'Value is required' error belongs
      // (e.g. create Visit Block with Priority field, create Visit, add to Waiting list, try changing the Priority to 'Not selected' via data block)
      .map((objectKey) => `${objectKey}: ${errors[objectKey].join(',')}`)
      .join('\n');
    if (errorMessage) {
      return errorMessage;
    }
  }
  console.error(validationProblemDetails.detail);
  return validationProblemDetails.title ?? 'Unknown error';
}
